export default __webpack_public_path__ + "static/media/fonts/alegreyasans-bold-webfont.c402a06b.woff2";